const Backbone = require('backbone');
var FinishModel = Backbone.Model.extend({
	defaults: {
		selected: false,
		available: true,
		mapRestrictions: false
	},

	/**
	 * isAvailable  - Shortcut for determining if a finish is available
	 * @description Currently only modified by products with location availability if not
	 * eligible for the customer's shipping address
	 * @default true
	 * @return {Boolean} If finish is available
	 */
	isAvailable: function() {
		return this.get('available');
	},

	/**
	 * hasMapRestriction - Shortcut for determining if the finish has MAP pricing restrictions
	 * @return {Boolean} If product has MAP restrictions
	 */
	hasMapRestriction: function() {
		return this.get('mapRestrictions');
	},

	/**
	 * isSelected - Helper to determine if a finish has been selected
	 * @description Each page should have a default select, this may be altered by `click` events
	 * @return {Boolean} If product is selected
	 */
	isSelected: function() {
		return this.get('selected');
	}
});

module.exports = FinishModel;
